import { Button, Tooltip, useTheme } from '@mui/material';
import React from 'react';
import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import UpdateIcon from '@mui/icons-material/Update';

// Smooth blinking animation
const blink = keyframes`
  0%, 50% {
    opacity: 1;
    transform: scale(1);
  }
  25% {
    opacity: 0.7;
    transform: scale(1.05);
  }
  75% {
    opacity: 0.8;
    transform: scale(1.02);
  }
`;

const BlinkingButton = styled(Button)`
  animation: ${blink} 2s ease-in-out infinite;
  
  &:hover {
    animation-play-state: paused;
  }
`;

export const NewVersionTooltip = () => {
	const { t } = useTranslation();
	const theme = useTheme();
	return <Tooltip title={t('common.newVersionInfo')}>
		<BlinkingButton 
			onClick={() => window.location.reload()} 
			sx={{ 
				backgroundColor: theme.palette.success.light, 
				color: theme.palette.warning.contrastText 
			}} 
			variant='contained' 
			startIcon={<UpdateIcon fontSize='small' />}
		>
			{t('common.newVersionAvailable')}
		</BlinkingButton>
	</Tooltip>;
};

export default NewVersionTooltip;
